/* global axios */

import ApiClient from './ApiClient';

class IntegrationsAPI extends ApiClient {
  constructor() {
    super('integrations/apps', { accountScoped: true });
  }

  connectSlack(code) {
    return axios.post(`${this.baseUrl()}/integrations/slack`, { code });
  }

  updateSlack({ referenceId }) {
    return axios.patch(`${this.baseUrl()}/integrations/slack`, {
      reference_id: referenceId,
    });
  }

  listAllSlackChannels() {
    return axios.get(`${this.baseUrl()}/integrations/slack/list_all_channels`);
  }

  createHook(hookData) {
    return axios.post(`${this.baseUrl()}/integrations/hooks`, hookData);
  }

  deleteHook(hookId) {
    return axios.delete(`${this.baseUrl()}/integrations/hooks/${hookId}`);
  }

  getCalComEventTypes() {
    return axios.get(`${this.baseUrl()}/integrations/cal_com/event_types`);
  }

  updateCalComEventType(eventTypeId) {
    return axios.patch(`${this.baseUrl()}/integrations/cal_com/event_type`, {
      event_type_id: eventTypeId,
    });
  }

  connectShopify({ shopDomain }) {
    return axios.post(`${this.baseUrl()}/integrations/shopify/auth`, {
      shop_domain: shopDomain,
    });
  }

  // Generic, provider-agnostic — `provider` is just whichever app id the
  // Email integrations page is showing (gmail today); this client never
  // branches on it.
  authorizeEmailProvider(provider) {
    return axios.post(
      `${this.baseUrl()}/integrations/email/${provider}/authorize`
    );
  }

  testEmailConnection(provider) {
    return axios.post(
      `${this.baseUrl()}/integrations/email/${provider}/test_connection`
    );
  }

  sendTestEmail(provider) {
    return axios.post(
      `${this.baseUrl()}/integrations/email/${provider}/send_test_email`
    );
  }
}

export default new IntegrationsAPI();
